import {createContext, useContext} from "react";
import type {Door, WorldPoint} from "@/dungeons/model/DungeonGeometry.ts";
import type {GameMasterAnnotationsController} from "@/tabletop/dungeon/useGameMasterAnnotations.ts";
import type {MapFeatureSelection} from "@/tabletop/dungeon/useMapFeatureSelection.ts";

export type PlacementMode = "annotation" | "light" | null;

export type GameMasterMapInteractions = {
    showAnnotations: boolean;
    setShowAnnotations: (value: boolean) => void;
    placementMode: PlacementMode;
    setPlacementMode: (mode: PlacementMode) => void;
    selection?: MapFeatureSelection;
    annotations: GameMasterAnnotationsController;
    closeMapPopovers: () => void;
    selectDoor: (door: Door) => void;
    selectLight: (id: string) => void;
    placeLight: (position: WorldPoint, combatantId?: string) => Promise<void>;
    addAttachedLight: (combatantId: string) => void;
    moveLight: (id: string, position: WorldPoint) => Promise<void>;
};

export const GameMasterMapInteractionContext = createContext<GameMasterMapInteractions | null>(null);

export function useGameMasterMapInteractions(): GameMasterMapInteractions {
    const context = useContext(GameMasterMapInteractionContext);
    if (!context) throw new Error("useGameMasterMapInteractions must be used within GameMasterMapInteractionProvider");
    return context;
}
